import {Component, OnDestroy, OnInit} from '@angular/core';
import {PageLayoutService, ProductListComponentService, ViewConfig} from '@spartacus/storefront';
import {DcpSearchProductComponent} from '../dcp-search-product/dcp-search-product.component';
import {GlobalMessageService} from '@spartacus/core';

type noSearchResultsContent = {
  title: string;
  paragraph: string;
};
@Component({
  selector: 'dcp-search-product-grid',
  templateUrl: './dcp-search-product-grid.component.html',
  styleUrls: ['./dcp-search-product-grid.component.scss']
})

export class DcpSearchProductGridComponent extends DcpSearchProductComponent implements OnInit, OnDestroy {
  emptyResultData: noSearchResultsContent[] = [
    {
      title: 'Check your entry for typos, spaces, or spelling errors',
      paragraph: 'For example, try "community" instead of "comunity".'
    },
    {
      title: 'Use synonyms or different words for your search entry',
      paragraph: 'For example, try "bpc" or "planning & consolidation" instead of "bopc".'
    },
    {
      title: 'Use specific keywords and phrases, not general terms',
      paragraph: 'For example, "crystal solutions" is better than "solutions".'
    }
  ]

  constructor(
    pageLayoutService: PageLayoutService,
    productListComponentService: ProductListComponentService,
    globalMessageService: GlobalMessageService,
    public scrollConfig: ViewConfig
  ) {
    super(pageLayoutService, productListComponentService, globalMessageService, scrollConfig);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
